import React from 'react';
import TableYearsNavArrowsRight from './TableYearsNavArrowsRight';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

const TableYearsNavArrowsRightContainer = () => {
  const { state: { columnState, data: { periods = [] } }, increaseVolumeTablePosition } = useScorecardContext();
  const { valueTableIndex, valueTableColumnCount } = columnState;
  const isDisabled = (valueTableIndex + valueTableColumnCount) >= periods.length;

  return (
    <TableYearsNavArrowsRight
      isDisabled={ isDisabled }
      increaseTablePosition={ increaseVolumeTablePosition }
    />
  );
};

export default TableYearsNavArrowsRightContainer;
